<form nz-form [formGroup]="form" nzLayout="vertical" nzSize="small">
    <div nz-row [nzGutter]="24">
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input formControlName="sequenceNo" />
                </nz-form-control>
                <nz-form-label nzRequired>Sequence Number</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <app-date-input formControlName="taxMonth" required [nzAllowClear]="false">
                    </app-date-input>
                </nz-form-control>
                <nz-form-label nzRequired>Tax Month</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input formControlName="importEntryNo" />
                </nz-form-control>
                <nz-form-label nzRequired>Import Entry No</nz-form-label>
            </nz-form-item>
        </div>
    </div>
    <div nz-row [nzGutter]="24">
        <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="6">
            <nz-form-item>
                <nz-form-control>
                    <app-supplier-select
                        formControlName="supplier"
                        (ngModelChange)="this.supplierChange($event)">
                    </app-supplier-select>
                </nz-form-control>
                <nz-form-label>Name Of Seller</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input formControlName="sellerName" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="6">
            <button type="button" nz-button (click)="inquire()" nzSize="large" [disabled]="this.supplierId === 0 || this.disabled" style="width: 100%">
                Inquiry
            </button>
        </div>
    </div>
    <div nz-row [nzGutter]="24">
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <app-date-input formControlName="releaseDate">
                    </app-date-input>
                </nz-form-control>
                <nz-form-label>Assessment/Release Date</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <app-date-input formControlName="importationDate">
                    </app-date-input>
                </nz-form-control>
                <nz-form-label>Date of Importation</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input formControlName="country" />
                </nz-form-control>
                <nz-form-label>Country of Origin</nz-form-label>
            </nz-form-item>
        </div>
    </div>
    <div nz-row [nzGutter]="24">
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzOffset="4">
            <nz-form-item>
                <nz-form-control>
                    <nz-select formControlName="vatRate" (ngModelChange)="recalculate('vatrate', $event)">
                        <nz-option nzLabel="10%" [nzValue]="10"></nz-option>
                        <nz-option nzLabel="12%" [nzValue]="12"></nz-option>
                    </nz-select>
                </nz-form-control>
                <nz-form-label nzRequired>VAT Rate</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <app-currency-input formControlName="totalLandedCost"
                        (ngModelChange)="recalculate('totalLandedCost', $event)" />
                </nz-form-control>
                <nz-form-label nzRequired>Total Landed Cost</nz-form-label>
            </nz-form-item>
        </div>
    </div>
    <div nz-row [nzGutter]="24">
        <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="6">
            <nz-form-item>
                <nz-form-control>
                    <app-currency-input formControlName="dutiableValue" (ngModelChange)="recalculate('dutiable', $event)" />
                </nz-form-control>
                <nz-form-label>Dutiable Value</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="6">
            <nz-form-item>
                <nz-form-control>
                    <app-currency-input formControlName="chargesBeforeRelease" />
                </nz-form-control>
                <nz-form-label>All Charges Before Release from Custom's Custody</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="6">
            <nz-form-item>
                <nz-form-control>
                    <app-currency-input formControlName="exempt" (ngModelChange)="recalculate('exempt', $event)" />
                </nz-form-control>
                <nz-form-label>Exempt</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="6">
            <nz-form-item>
                <nz-form-control>
                    <app-currency-input formControlName="taxableGoods" />
                </nz-form-control>
                <nz-form-label>Taxable Goods</nz-form-label>
            </nz-form-item>
        </div>
    </div>
    <div nz-row [nzGutter]="24">
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input formControlName="orNumber" />
                </nz-form-control>
                <nz-form-label nzRequired>OR Number</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <app-date-input formControlName="dateOfVATPayment">
                    </app-date-input>
                </nz-form-control>
                <nz-form-label nzRequired>Date VAT Payment</nz-form-label>
            </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8">
            <nz-form-item>
                <nz-form-control>
                    <app-currency-input formControlName="vat" />
                </nz-form-control>
                <nz-form-label nzRequired>VAT</nz-form-label>
            </nz-form-item>
        </div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="24">
            <nz-table #basicTable nzBordered="true" [nzTitle]="tableTitle" [nzLoading]="this.loading" [nzData]="importedGoodsItems">
                <thead>
                    <tr>
                        <th nzLabel="Select all" (nzChecked)="false"></th>
                        <th [nzAlign]="'center'">Doc #</th>
                        <th [nzAlign]="'center'">Date</th>
                        <th [nzAlign]="'center'">GL Account</th>
                        <th>Description</th>
                        <th>Reference No</th>
                        <th [nzAlign]="'right'">Amount</th>
                        <th>Tax Code</th>
                        <th>Tax Rate</th>
                        <th [nzAlign]="'right'">Tax Amount</th>
                        <th [nzAlign]="'right'">Net Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let line of importedGoodsItems">
                        <td>
                            <label nz-checkbox [nzChecked]="line.isCheck" (nzCheckedChange)="check($event, line)"
                                [nzDisabled]="this.checkboxDisabled">
                            </label>
                        </td>
                        <td>{{line.docCode}}</td>
                        <td>{{line.docDate | date:'MM/dd/yyyy'}}</td>
                        <td>{{line.accCode}}</td>
                        <td>{{line.description}}</td>
                        <td>{{line.referenceNo}}</td>
                        <td nzAlign="right">{{line.amountLocal | price}}</td>
                        <td>SR-PNCI</td>
                        <td nzAlign="right">{{line.taxRate}}</td>
                        <td nzAlign="right">{{line.taxAmountLocal | price}}</td>
                        <td nzAlign="right">{{line.netAmountLocal | price}}</td>
                    </tr>
                </tbody>
            </nz-table>
            <ng-template #tableTitle>
                <strong style="font-size: 17px;">Import Goods Item</strong>
            </ng-template>
        </div>
    </div>
</form>
<ng-template #footer>
  <button type="button" nz-button 
  *ngIf="this.hasReliefImportation && this.importedGoodsItems !== null"
  [disabled]="!editing"
  (click)="untagBtn()"
  >
    Untag as Imported Goods
  </button>
  <button type="button" nz-button (click)="cancelBtn()">Cancel</button>
  <button type="button" nz-button (click)="okbtn()">Ok</button>
</ng-template>